<span
  [matTooltip]="tooltip() || label()"
  matTooltipClass="toolbar-button-tooltip"
  [attr.tabindex]="disabled() ? '0' : null"
  [attr.aria-label]="disabled() ? tooltip() || label() : null">
  <button class="align-vertical" [disabled]="disabled()" [attr.aria-label]="tooltip() || label()">
    <mat-icon>{{ icon() }}</mat-icon>
    <div>{{ label() }}</div>
  </button>
</span>
